<template>
  <div>
    <h3 class="title is-3 between-center">
            <span>
                <span>Applications Under Review</span>
                <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                    <o-icon pack="fa" icon="gear" size="is-small"/>
                </a>
            </span>
    </h3>
    <o-table
        :data="paginatedData"

        v-if="isTableVisible"
        :bordered="table.bordered"
        :striped="table.striped"
        :narrowed="table.narrowed"
        :checkable="table.checkable"
        :mobile-cards="table.mobileCards"
        :paginated="table.paginated"
        :pagination-simple="table.paginationSimple"
        :per-page="table.perPage"
        :default-sort-direction="table.defaultSortDirection"
        :default-sort="table.defaultSort"

        :selected.sync="selected"
        :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"

        :loading="loading"
        :total="total"
        backend-sorting
        backend-pagination
        @page-change="onPageChange"
        @sort="onSort"
    >
      <o-table-column
          v-for="col in tableColumns"
          v-bind="col"
          #default="{ row }"
          :field="col.field"
          :label="col.field === 'actions' ? '' : col.label"
          :sortable="col.sortable"
      >
            <span v-if="col.field === 'created_at'">
              {{ $filters.date(row[col.field]) }}
            </span>
        <span v-if="col.field === 'applicant_id' && row[col.field] !== undefined">
              <router-link :to="{ name: 'contacts.show', params: { slug: row.contact_id } }">
                {{ contactNameById($filters.valueOrDefault(row[col.field]), '–') }}
              </router-link>
            </span>
        <span v-if="col.field === 'type'">
              {{ applicationTypeNameById(row[col.field]) }}
            </span>
        <span v-if="col.field === 'numeric_type'">
              {{ applicationName(row) }}
            </span>
        <span v-if="col.field === 'project_name'">
              <router-link :to="{ name: 'projects.show', params: { slug: row.project_id } }">
                {{ $filters.valueOrDefault(row[col.field], '-') }}
              </router-link>
            </span>
        <span v-if="col.field === 'project_address'">
              <router-link :to="{ name: 'projects.show', params: { slug: row.project_id } }">
                {{ $filters.valueOrDefault(row[col.field], '-') }}
              </router-link>
            </span>
        <span v-if="col.field === 'project_manager_id'">
              <router-link :to="{ name: 'users.show', params: { slug: row.project_manager_id } }">
                {{ userNameById($filters.valueOrDefault(row[col.field]), '-') }}
              </router-link>
            </span>
        <span v-if="col.field === 'job_number'">
              {{ $filters.valueOrDefault(row[col.field]) }}
            </span>
      </o-table-column>

      <template #empty>
        <div class="has-text-centered">
          This table is empty!
        </div>
      </template>
    </o-table>
   <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
      <table-settings-modal :slug="tableName"/>
    </o-modal>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Table from './../../../../mixins/Table'

export default {
  mixins: [Table],

  props: {
    urlFilterEnabled: false,
    year: {
      required: true
    }
  },

  data() {
    return {
      tableName: 'applications-under-review',
      isTableSettingsModalActive: false
    }
  },

  computed: {
    ...mapGetters([
      'applicationTypeNameById',
      'categoryNameById',
      'applicationName',
      'contactNameById',
      'projectNameById',
      'userNameById'
    ]),

    ...mapGetters({
      itemsByIds: 'applicationsUnderReviewByIds',
    })
  },

  watch: {
    year(year) {
      this.filters.year = year
      this.fetchPaginatedData()
    }
  },

  created() {
    this.filters = {
      year: 2017
    }
  },

  mounted() {
    this.fetchPaginatedData()
  },

  methods: {
    ...mapActions({
      fetchData: 'fetchApplicationsUnderReview'
    })
  }
}
</script>
